import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import { MainButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import LocalPickerPick from 'components/picker/pick/local/local_picker_pick'
import pickerFileTypes from 'helpers/enums/picker/pickerFileTypes'
import { TextInput } from 'components/dpc_input'

import styles from './video_settings_support_section.scss'

class VideoSettingsSupportSection extends PureComponent {
	acceptedFiles = () => [pickerFileTypes.IMAGE_NO_PDF]

	acceptedHandoutsFiles = () => [pickerFileTypes.PDF]

	constructor(props) {
		super(props)

		this.state = {
			credits: '',
		}
	}

	setCredits = event => {
		this.setState({
			credits: event.target.value,
		})
	}

	onSaveCredits = () => {
		this.props.onSaveCredits(this.state.credits)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='header'>
					<h2 styleName='header-title'>
						{localize('interactive_video_settingsModal_support_title')}
					</h2>
				</div>
				<div styleName='settings'>
					<LocalPickerPick
						onChange={this.props.onPosterPicked}
						onFileError={this.props.onPosterError}
						accept={this.acceptedFiles()} >
						<TextLink>
							{localize('interactive_video_settingsModal_support_update_poster')}
						</TextLink>
					</LocalPickerPick>
					<LocalPickerPick
						onChange={this.props.onTranscriptPicked}
						onFileError={this.props.onTranscriptError}
						accept={this.acceptedHandoutsFiles()} >
						<TextLink>
							{localize('interactive_video_settingsModal_support_transcript')}
						</TextLink>
					</LocalPickerPick>
					<LocalPickerPick
						onChange={this.props.onQuestionPicked}
						onFileError={this.props.onQuestionError}
						accept={this.acceptedHandoutsFiles()} >
						<TextLink>
							{localize('interactive_video_settingsModal_support_question')}
						</TextLink>
					</LocalPickerPick>
					<div styleName='credits'>
						<div styleName='header'>
							<h2 styleName='header-title'>
								{localize('interactive_video_select_credits')}
							</h2>
						</div>
						<p styleName='credits-label'>{this.props.credits}</p>
						<div styleName='credits-form'>
							<div styleName='credits-form-container-input'>
								<TextInput
									placeholder={localize('interactive_video_select_credits')}
									onChange={this.setCredits}
									value={this.state.credits}
								/>
							</div>
							<MainButton
								onClick={this.onSaveCredits}
								styleName='credits-form-button'
							>
								{localize('global_save')}
							</MainButton>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

VideoSettingsSupportSection.propTypes = {
	onPosterPicked: PropTypes.func,
	onPosterError: PropTypes.func,
	onTranscriptPicked: PropTypes.func,
	onTranscriptError: PropTypes.func,
	onQuestionPicked: PropTypes.func,
	onQuestionError: PropTypes.func,
	onSaveCredits: PropTypes.func,
	credits: PropTypes.string.isRequired,
}

VideoSettingsSupportSection.defaultProps = {
	onPosterPicked: () => {},
	onPosterError: () => {},
	onTranscriptPicked: () => {},
	onTranscriptError: () => {},
	onQuestionPicked: () => {},
	onQuestionError: () => {},
	onSaveCredits: () => {},
}

export default CSSModules(VideoSettingsSupportSection, styles, {allowMultiple: true})
